import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const UsageCtx = createContext(null);

export function UsageProvider({ children }) {
  const { user } = useAuth();
  const [usage, setUsage] = useState(null);

  const refresh = useCallback(async () => {
    if (!user) return;
    try {
      const { data } = await api.get("/usage/today");
      setUsage(data);
    } catch (e) {
      console.warn("usage/today fetch failed", e?.message || e);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <UsageCtx.Provider value={{ usage, refresh }}>
      {children}
    </UsageCtx.Provider>
  );
}

export function useUsage() {
  return useContext(UsageCtx) || { usage: null, refresh: () => {} };
}
